export default "__VITE_ASSET__BXQtryKB__"